/**
 * @generated SignedSource<<e51a103afd96dbb09707f639c60dc866>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingPunchPassContent_Booking$data = {
  readonly appliedPunchPass?: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PunchPassListItem_PunchPass">;
  } | null | undefined;
  readonly id: string;
  readonly ownerClient: {
    readonly fullName?: string;
  } | null | undefined;
  readonly punchPassOptionsInvalid?: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PunchPassListItem_PunchPass">;
  } | null | undefined> | null | undefined;
  readonly punchPassOptionsValid?: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PunchPassListItem_PunchPass">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "BookingPunchPassContent_Booking";
};
export type BookingPunchPassContent_Booking$key = {
  readonly " $data"?: BookingPunchPassContent_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingPunchPassContent_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  }
],
v2 = [
  (v0/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "PunchPassListItem_PunchPass"
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PunchPass",
    "kind": "LinkedField",
    "name": "appliedPunchPass",
    "plural": false,
    "selections": (v2/*: any*/),
    "storageKey": null
  },
  {
    "alias": "punchPassOptionsValid",
    "args": [
      {
        "kind": "Literal",
        "name": "valid",
        "value": true
      }
    ],
    "concreteType": "PunchPass",
    "kind": "LinkedField",
    "name": "punchPassOptions",
    "plural": true,
    "selections": (v2/*: any*/),
    "storageKey": "punchPassOptions(valid:true)"
  },
  {
    "alias": "punchPassOptionsInvalid",
    "args": [
      {
        "kind": "Literal",
        "name": "valid",
        "value": false
      }
    ],
    "concreteType": "PunchPass",
    "kind": "LinkedField",
    "name": "punchPassOptions",
    "plural": true,
    "selections": (v2/*: any*/),
    "storageKey": "punchPassOptions(valid:false)"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingPunchPassContent_Booking",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerClient",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "Member",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "Customer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v3/*: any*/),
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v3/*: any*/),
      "type": "LessonBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "7b2d513e73f8bf80ce6dbd52813f1f3b";

export default node;
